import React from 'react';
import { Typography, Progress } from 'antd';
import classNames from 'classnames';

const { Text } = Typography;

/**
 * SummaryProgressBar Component
 *
 * Renders progress bar section with labels and values
 */
export const SummaryProgressBar = ({ progressBar = [] }) => {
    if (!Array.isArray(progressBar) || progressBar.length === 0) {
        return null;
    }

    return (
        <span className="rm-card-item block summary-progress-content">
            {progressBar.map((detail, idx) => {
                const rowClassName = classNames('summary-progress-bar-row', 'rm-card-item', 'block');

                // Calculate percentage based on totalValue and progressValue
                const totalValue = parseInt(detail.totalValue, 10);
                const progressValue = detail.progressValue;
                const percent = totalValue ? (progressValue / totalValue) * 100 : 0;

                return (
                    <span key={idx} className={rowClassName}>
                        <span className="summary-progress-bar-header">
                            <Text className="summary-progress-label">{detail.label}</Text>
                            <Text className="semi-bold summary-progress-value">{detail.totalValue}</Text>
                        </span>
                        <Progress percent={percent} showInfo={false} strokeVariant={detail.variant} />
                    </span>
                );
            })}
        </span>
    );
};

SummaryProgressBar.displayName = 'SummaryProgressBar';

export default SummaryProgressBar;
